const BaseModel = require('base/baseModel'),
    getPasswordPolicyErrorMessage = require('shared/helpers/getPasswordPolicyErrorMessage'),
    M = require('shared/messages/messages');

module.exports = BaseModel.extend({
    urlRoot: './api/password',
    validation: {
        newPassword: {
            required: true,
            msg: M.enterPassword()
        },
        passwordConfirm: {
            equalTo: 'newPassword',
            msg: M.passwordConfirmationMismatch()
        }
    },
    applyPasswordPolicy: function () {
        let passwordPolicy = this.get('passwordPolicy');
        if (passwordPolicy && passwordPolicy.clientRegex) {
            this.validation.newPassword = {
                pattern: passwordPolicy.clientRegex,
                msg: getPasswordPolicyErrorMessage(new Backbone.Model(passwordPolicy))
            };
        }
        else {
            this.validation.newPassword = {
                required: true,
                msg: M.enterPassword()
            };
        }
    },
    idAttribute: 'resetKey'
});
